/**
 * @file sellerStore.ts
 * @module redux/sellerStore
 * @description Configures the Redux store and state wiring used to manage shared seller data across the admin application.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.3.0
 */

// src/store.js
import { createStore } from 'redux';
import { listSeller } from '../utils/storeString';
const initialState = {
  currentTab: -1,
  page: 1,
};
// Define a reducer function
const rootReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case listSeller.currentTab:
      return { ...state, currentTab: action.payload };
    case listSeller.page:
      return { ...state, page: action.payload };
    case listSeller.limit:
      return { ...state, limit: action.payload };
    default:
      return state;
  }
};
// Create the Redux store
const store = createStore(rootReducer);
export default store;
